module.exports = __webpack_public_path__ + "img/1-4.d529b50a.svg";